import { serverHttp } from "@/plugins/axios";

export const plan = function(planId: number) {
    return serverHttp.get(`/api/portal/plans/${planId}/detail`).then(response => {
        return response.data.data;
    });
};

export const studentRegistrationInfo = function(planId: number) {
    return serverHttp.get(`/api/enrollments/plans/${planId}/student-registration`).then(response => {
        return response.data.data;
    });
};

export const registrationInfo = function(planId: number) {
    return serverHttp.get(`/api/enrollments/plans/${planId}/registration-info`).then(response => {
        return response.data.data;
    });
};

export const registration = function(planId: number) {
    return serverHttp.post(`/api/enrollments/plans/${planId}/fast-student-registration`, {}).then(response => {
        return response.data.data;
    });
};

export const updateRegistration = function(planId: number, formData: any) {
    return serverHttp.put(`/api/enrollments/plans/${planId}/student-registration`, formData).then(response => {
        return response.data.data;
    });
};

export const createRegistration = function(planId: number, formData: any) {
    return serverHttp.post(`/api/enrollments/plans/${planId}/student-registration`, formData).then(response => {
        return response.data.data;
    });
};

export const feeOrder = function(planId: number) {
    return serverHttp.get(`/api/enrollments/plans/${planId}/student-registration/fee-order`, {}).then(response => {
        return response.data.data;
    });
};
